/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.PatientApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CancelPlatformUserMembershipRequest,
  ChangeMembershipRequest,
  DisplayMembershipChangeOptions,
  DisplayMembershipChangeRescinded,
  DisplayMembershipFreeze,
  DisplayMembershipPaymentMethodUpdateIntentResponse,
  DisplayMembershipPendingChange,
  DisplayMembershipReactivated,
  GetPlatformUserMembershipsStatusResult,
  MembershipCancellationReasonModel,
  PlatformUserMembershipModel,
  ProblemDetails,
  RequestMembershipFreezeRequest
} from '../model';

import { customAxios } from '../../custom-axios';
import type { ErrorType } from '../../custom-axios';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Returns a list of PlatformUserMemberships that belong to the PlatformUser.
 */
export const getMyMemberships = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<PlatformUserMembershipModel[]>(
      {url: `/api/v1/platform-user-memberships`, method: 'GET', signal
    },
      options);
    }




export const getGetMyMembershipsQueryKey = () => {
    return [
    `/api/v1/platform-user-memberships`
    ] as const;
    }


export const getGetMyMembershipsQueryOptions = <TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyMembershipsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyMemberships>>> = ({ signal }) => getMyMemberships(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMyMembershipsQueryResult = NonNullable<Awaited<ReturnType<typeof getMyMemberships>>>
export type GetMyMembershipsQueryError = ErrorType<unknown>


/**
 * @summary Returns a list of PlatformUserMemberships that belong to the PlatformUser.
 */

export function useGetMyMemberships<TData = Awaited<ReturnType<typeof getMyMemberships>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMyMemberships>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMyMembershipsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Requests the cancellation of a given platform user's membership.
By default this cancellation is applied at the end of the period.
Memberships that are in a dunning state are canceled immediately.
 */
export const cancelMembership = (
    platformUserMembershipId: string,
    cancelPlatformUserMembershipRequest: CancelPlatformUserMembershipRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPlatformUserMembershipsStatusResult>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/cancel-membership`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: cancelPlatformUserMembershipRequest, signal
    },
      options);
    }




export const getCancelMembershipMutationKey = () => ['cancelMembership'] as const;

export const getCancelMembershipMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMembership>>, TError,CancelMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelMembership>>, TError,CancelMembershipMutationVariables, TContext> => {

const mutationKey = getCancelMembershipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelMembership>>, CancelMembershipMutationVariables> = (props) => {
          const {platformUserMembershipId,data} = props ?? {};

          return  cancelMembership(platformUserMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CancelMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof cancelMembership>>>
    export type CancelMembershipMutationBody = CancelPlatformUserMembershipRequest
    export type CancelMembershipMutationError = ErrorType<void>
    export type CancelMembershipMutationVariables = {platformUserMembershipId: string;data: CancelPlatformUserMembershipRequest}

    /**
 * @summary Requests the cancellation of a given platform user's membership.
By default this cancellation is applied at the end of the period.
Memberships that are in a dunning state are canceled immediately.
 */
export const useCancelMembership = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelMembership>>, TError,CancelMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof cancelMembership>>,
        TError,
        CancelMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getCancelMembershipMutationOptions(options));
    }
    /**
 * @summary Requests the reactivation of a given platform user's membership that was scheduled to be canceled.
 */
export const keepMembership = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPlatformUserMembershipsStatusResult>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/keep-membership`, method: 'PUT', signal
    },
      options);
    }




export const getKeepMembershipMutationKey = () => ['keepMembership'] as const;

export const getKeepMembershipMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keepMembership>>, TError,KeepMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof keepMembership>>, TError,KeepMembershipMutationVariables, TContext> => {

const mutationKey = getKeepMembershipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof keepMembership>>, KeepMembershipMutationVariables> = (props) => {
          const {platformUserMembershipId} = props ?? {};

          return  keepMembership(platformUserMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type KeepMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof keepMembership>>>

    export type KeepMembershipMutationError = ErrorType<void>
    export type KeepMembershipMutationVariables = {platformUserMembershipId: string}

    /**
 * @summary Requests the reactivation of a given platform user's membership that was scheduled to be canceled.
 */
export const useKeepMembership = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof keepMembership>>, TError,KeepMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof keepMembership>>,
        TError,
        KeepMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getKeepMembershipMutationOptions(options));
    }
    /**
 * @summary Retries the payment of a platform user membership that is already in dunning state.
 */
export const retryMembershipPayment = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPlatformUserMembershipsStatusResult>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/retry-membership-payment`, method: 'PUT', signal
    },
      options);
    }




export const getRetryMembershipPaymentMutationKey = () => ['retryMembershipPayment'] as const;

export const getRetryMembershipPaymentMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryMembershipPayment>>, TError,RetryMembershipPaymentMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof retryMembershipPayment>>, TError,RetryMembershipPaymentMutationVariables, TContext> => {

const mutationKey = getRetryMembershipPaymentMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof retryMembershipPayment>>, RetryMembershipPaymentMutationVariables> = (props) => {
          const {platformUserMembershipId} = props ?? {};

          return  retryMembershipPayment(platformUserMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RetryMembershipPaymentMutationResult = NonNullable<Awaited<ReturnType<typeof retryMembershipPayment>>>

    export type RetryMembershipPaymentMutationError = ErrorType<void>
    export type RetryMembershipPaymentMutationVariables = {platformUserMembershipId: string}

    /**
 * @summary Retries the payment of a platform user membership that is already in dunning state.
 */
export const useRetryMembershipPayment = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof retryMembershipPayment>>, TError,RetryMembershipPaymentMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof retryMembershipPayment>>,
        TError,
        RetryMembershipPaymentMutationVariables,
        TContext
      > => {
      return useMutation(getRetryMembershipPaymentMutationOptions(options));
    }
    /**
 * @summary Reactivate a membership that has been canceled but not yet expired.
 */
export const reactivateUnexpiredMembership = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipReactivated>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/reactivate`, method: 'POST', signal
    },
      options);
    }




export const getReactivateUnexpiredMembershipMutationKey = () => ['reactivateUnexpiredMembership'] as const;

export const getReactivateUnexpiredMembershipMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUnexpiredMembership>>, TError,ReactivateUnexpiredMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof reactivateUnexpiredMembership>>, TError,ReactivateUnexpiredMembershipMutationVariables, TContext> => {

const mutationKey = getReactivateUnexpiredMembershipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof reactivateUnexpiredMembership>>, ReactivateUnexpiredMembershipMutationVariables> = (props) => {
          const {platformUserMembershipId} = props ?? {};

          return  reactivateUnexpiredMembership(platformUserMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ReactivateUnexpiredMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof reactivateUnexpiredMembership>>>

    export type ReactivateUnexpiredMembershipMutationError = ErrorType<unknown>
    export type ReactivateUnexpiredMembershipMutationVariables = {platformUserMembershipId: string}

    /**
 * @summary Reactivate a membership that has been canceled but not yet expired.
 */
export const useReactivateUnexpiredMembership = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof reactivateUnexpiredMembership>>, TError,ReactivateUnexpiredMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof reactivateUnexpiredMembership>>,
        TError,
        ReactivateUnexpiredMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getReactivateUnexpiredMembershipMutationOptions(options));
    }
    /**
 * @summary Returns a list of PlatformUserMemberships that belong to the PlatformUser with their status
 */
export const getPlatformUserMembershipsStatus = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<GetPlatformUserMembershipsStatusResult[]>(
      {url: `/api/v1/platform-user-memberships/status`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformUserMembershipsStatusQueryKey = () => {
    return [
    `/api/v1/platform-user-memberships/status`
    ] as const;
    }


export const getGetPlatformUserMembershipsStatusQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformUserMembershipsStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>> = ({ signal }) => getPlatformUserMembershipsStatus(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformUserMembershipsStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>>
export type GetPlatformUserMembershipsStatusQueryError = ErrorType<unknown>


/**
 * @summary Returns a list of PlatformUserMemberships that belong to the PlatformUser with their status
 */

export function useGetPlatformUserMembershipsStatus<TData = Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipsStatus>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformUserMembershipsStatusQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Creates an embedded payment-method update intent for a membership.
 */
export const createStripeSessionForUpdate = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipPaymentMethodUpdateIntentResponse>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/create-stripe-update-session`, method: 'POST', signal
    },
      options);
    }




export const getCreateStripeSessionForUpdateMutationKey = () => ['createStripeSessionForUpdate'] as const;

export const getCreateStripeSessionForUpdateMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStripeSessionForUpdate>>, TError,CreateStripeSessionForUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createStripeSessionForUpdate>>, TError,CreateStripeSessionForUpdateMutationVariables, TContext> => {

const mutationKey = getCreateStripeSessionForUpdateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createStripeSessionForUpdate>>, CreateStripeSessionForUpdateMutationVariables> = (props) => {
          const {platformUserMembershipId} = props ?? {};

          return  createStripeSessionForUpdate(platformUserMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateStripeSessionForUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof createStripeSessionForUpdate>>>

    export type CreateStripeSessionForUpdateMutationError = ErrorType<unknown>
    export type CreateStripeSessionForUpdateMutationVariables = {platformUserMembershipId: string}

    /**
 * @summary Creates an embedded payment-method update intent for a membership.
 */
export const useCreateStripeSessionForUpdate = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createStripeSessionForUpdate>>, TError,CreateStripeSessionForUpdateMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createStripeSessionForUpdate>>,
        TError,
        CreateStripeSessionForUpdateMutationVariables,
        TContext
      > => {
      return useMutation(getCreateStripeSessionForUpdateMutationOptions(options));
    }
    /**
 * @summary Fetches the cancellation reasons for a membership.
 */
export const getPlatformUserMembershipCancellationReasons = (

 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<MembershipCancellationReasonModel[]>(
      {url: `/api/v1/platform-user-memberships/cancellation-reasons`, method: 'GET', signal
    },
      options);
    }




export const getGetPlatformUserMembershipCancellationReasonsQueryKey = () => {
    return [
    `/api/v1/platform-user-memberships/cancellation-reasons`
    ] as const;
    }


export const getGetPlatformUserMembershipCancellationReasonsQueryOptions = <TData = Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPlatformUserMembershipCancellationReasonsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>> = ({ signal }) => getPlatformUserMembershipCancellationReasons(requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPlatformUserMembershipCancellationReasonsQueryResult = NonNullable<Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>>
export type GetPlatformUserMembershipCancellationReasonsQueryError = ErrorType<unknown>


/**
 * @summary Fetches the cancellation reasons for a membership.
 */

export function useGetPlatformUserMembershipCancellationReasons<TData = Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPlatformUserMembershipCancellationReasons>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPlatformUserMembershipCancellationReasonsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Requests a freeze on the platform user's membership for a whole number of billing
periods. The request is pending until the provider approves or denies it.
 */
export const requestMembershipFreeze = (
    platformUserMembershipId: string,
    requestMembershipFreezeRequest: RequestMembershipFreezeRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipFreeze>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/freeze-requests`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: requestMembershipFreezeRequest, signal
    },
      options);
    }




export const getRequestMembershipFreezeMutationKey = () => ['requestMembershipFreeze'] as const;

export const getRequestMembershipFreezeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestMembershipFreeze>>, TError,RequestMembershipFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof requestMembershipFreeze>>, TError,RequestMembershipFreezeMutationVariables, TContext> => {

const mutationKey = getRequestMembershipFreezeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof requestMembershipFreeze>>, RequestMembershipFreezeMutationVariables> = (props) => {
          const {platformUserMembershipId,data} = props ?? {};

          return  requestMembershipFreeze(platformUserMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RequestMembershipFreezeMutationResult = NonNullable<Awaited<ReturnType<typeof requestMembershipFreeze>>>
    export type RequestMembershipFreezeMutationBody = RequestMembershipFreezeRequest
    export type RequestMembershipFreezeMutationError = ErrorType<void>
    export type RequestMembershipFreezeMutationVariables = {platformUserMembershipId: string;data: RequestMembershipFreezeRequest}

    /**
 * @summary Requests a freeze on the platform user's membership for a whole number of billing
periods. The request is pending until the provider approves or denies it.
 */
export const useRequestMembershipFreeze = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof requestMembershipFreeze>>, TError,RequestMembershipFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof requestMembershipFreeze>>,
        TError,
        RequestMembershipFreezeMutationVariables,
        TContext
      > => {
      return useMutation(getRequestMembershipFreezeMutationOptions(options));
    }
    /**
 * @summary Withdraws the platform user's own pending freeze request.
 */
export const withdrawMembershipFreezeRequest = (
    platformUserMembershipId: string,
    membershipFreezeId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/freeze-requests/${membershipFreezeId}`, method: 'DELETE', signal
    },
      options);
    }




export const getWithdrawMembershipFreezeRequestMutationKey = () => ['withdrawMembershipFreezeRequest'] as const;

export const getWithdrawMembershipFreezeRequestMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>, TError,WithdrawMembershipFreezeRequestMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>, TError,WithdrawMembershipFreezeRequestMutationVariables, TContext> => {

const mutationKey = getWithdrawMembershipFreezeRequestMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>, WithdrawMembershipFreezeRequestMutationVariables> = (props) => {
          const {platformUserMembershipId,membershipFreezeId} = props ?? {};

          return  withdrawMembershipFreezeRequest(platformUserMembershipId,membershipFreezeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type WithdrawMembershipFreezeRequestMutationResult = NonNullable<Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>>

    export type WithdrawMembershipFreezeRequestMutationError = ErrorType<void>
    export type WithdrawMembershipFreezeRequestMutationVariables = {platformUserMembershipId: string;membershipFreezeId: string}

    /**
 * @summary Withdraws the platform user's own pending freeze request.
 */
export const useWithdrawMembershipFreezeRequest = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>, TError,WithdrawMembershipFreezeRequestMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof withdrawMembershipFreezeRequest>>,
        TError,
        WithdrawMembershipFreezeRequestMutationVariables,
        TContext
      > => {
      return useMutation(getWithdrawMembershipFreezeRequestMutationOptions(options));
    }
    /**
 * @summary Resumes the platform user's own frozen membership early: the Stripe pause is cleared
and, when the freeze has already started, billing re-anchors to now — the member is
charged the membership price immediately and their billing date moves to today.
 */
export const resumeMembershipFreeze = (
    platformUserMembershipId: string,
    membershipFreezeId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipFreeze>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/freeze/${membershipFreezeId}/resume`, method: 'PUT', signal
    },
      options);
    }




export const getResumeMembershipFreezeMutationKey = () => ['resumeMembershipFreeze'] as const;

export const getResumeMembershipFreezeMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeMembershipFreeze>>, TError,ResumeMembershipFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof resumeMembershipFreeze>>, TError,ResumeMembershipFreezeMutationVariables, TContext> => {

const mutationKey = getResumeMembershipFreezeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof resumeMembershipFreeze>>, ResumeMembershipFreezeMutationVariables> = (props) => {
          const {platformUserMembershipId,membershipFreezeId} = props ?? {};

          return  resumeMembershipFreeze(platformUserMembershipId,membershipFreezeId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ResumeMembershipFreezeMutationResult = NonNullable<Awaited<ReturnType<typeof resumeMembershipFreeze>>>

    export type ResumeMembershipFreezeMutationError = ErrorType<void>
    export type ResumeMembershipFreezeMutationVariables = {platformUserMembershipId: string;membershipFreezeId: string}

    /**
 * @summary Resumes the platform user's own frozen membership early: the Stripe pause is cleared
and, when the freeze has already started, billing re-anchors to now — the member is
charged the membership price immediately and their billing date moves to today.
 */
export const useResumeMembershipFreeze = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof resumeMembershipFreeze>>, TError,ResumeMembershipFreezeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof resumeMembershipFreeze>>,
        TError,
        ResumeMembershipFreezeMutationVariables,
        TContext
      > => {
      return useMutation(getResumeMembershipFreezeMutationOptions(options));
    }
    /**
 * @summary Returns the membership's in-flight (pending, approved, or active) freeze, or 204
when none exists.
 */
export const getMembershipFreeze = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipFreeze>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/freeze`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipFreezeQueryKey = (platformUserMembershipId: string,) => {
    return [
    `/api/v1/platform-user-memberships/${platformUserMembershipId}/freeze`
    ] as const;
    }


export const getGetMembershipFreezeQueryOptions = <TData = Awaited<ReturnType<typeof getMembershipFreeze>>, TError = ErrorType<unknown>>(platformUserMembershipId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembershipFreeze>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipFreezeQueryKey(platformUserMembershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembershipFreeze>>> = ({ signal }) => getMembershipFreeze(platformUserMembershipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformUserMembershipId !== null && platformUserMembershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembershipFreeze>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMembershipFreezeQueryResult = NonNullable<Awaited<ReturnType<typeof getMembershipFreeze>>>
export type GetMembershipFreezeQueryError = ErrorType<unknown>


/**
 * @summary Returns the membership's in-flight (pending, approved, or active) freeze, or 204
when none exists.
 */

export function useGetMembershipFreeze<TData = Awaited<ReturnType<typeof getMembershipFreeze>>, TError = ErrorType<unknown>>(
 platformUserMembershipId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembershipFreeze>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMembershipFreezeQueryOptions(platformUserMembershipId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Adds RepeatCash to a user's account by claiming an available membership Beauty Bank choice.
 */
export const createRepeatCashTransaction = (
    platformUserMembershipId: string,
    createRepeatCashTransactionBody: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<void>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/redeem/repeat-cash`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createRepeatCashTransactionBody, signal
    },
      options);
    }




export const getCreateRepeatCashTransactionMutationKey = () => ['createRepeatCashTransaction'] as const;

export const getCreateRepeatCashTransactionMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRepeatCashTransaction>>, TError,CreateRepeatCashTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof createRepeatCashTransaction>>, TError,CreateRepeatCashTransactionMutationVariables, TContext> => {

const mutationKey = getCreateRepeatCashTransactionMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createRepeatCashTransaction>>, CreateRepeatCashTransactionMutationVariables> = (props) => {
          const {platformUserMembershipId,data} = props ?? {};

          return  createRepeatCashTransaction(platformUserMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateRepeatCashTransactionMutationResult = NonNullable<Awaited<ReturnType<typeof createRepeatCashTransaction>>>
    export type CreateRepeatCashTransactionMutationBody = string
    export type CreateRepeatCashTransactionMutationError = ErrorType<void>
    export type CreateRepeatCashTransactionMutationVariables = {platformUserMembershipId: string;data: string}

    /**
 * @summary Adds RepeatCash to a user's account by claiming an available membership Beauty Bank choice.
 */
export const useCreateRepeatCashTransaction = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createRepeatCashTransaction>>, TError,CreateRepeatCashTransactionMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createRepeatCashTransaction>>,
        TError,
        CreateRepeatCashTransactionMutationVariables,
        TContext
      > => {
      return useMutation(getCreateRepeatCashTransactionMutationOptions(options));
    }
    /**
 * @summary Returns the admin-configured upgrade/downgrade options for the member's
enrollment, with per-target eligibility (locked downgrades carry the
commitment unlock date) and any pending scheduled change.
 */
export const getMembershipChangeOptions = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipChangeOptions>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/change-options`, method: 'GET', signal
    },
      options);
    }




export const getGetMembershipChangeOptionsQueryKey = (platformUserMembershipId: string,) => {
    return [
    `/api/v1/platform-user-memberships/${platformUserMembershipId}/change-options`
    ] as const;
    }


export const getGetMembershipChangeOptionsQueryOptions = <TData = Awaited<ReturnType<typeof getMembershipChangeOptions>>, TError = ErrorType<void>>(platformUserMembershipId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembershipChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMembershipChangeOptionsQueryKey(platformUserMembershipId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMembershipChangeOptions>>> = ({ signal }) => getMembershipChangeOptions(platformUserMembershipId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: platformUserMembershipId !== null && platformUserMembershipId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMembershipChangeOptions>>, TError, TData> & { queryKey: QueryKey }
}

export type GetMembershipChangeOptionsQueryResult = NonNullable<Awaited<ReturnType<typeof getMembershipChangeOptions>>>
export type GetMembershipChangeOptionsQueryError = ErrorType<void>


/**
 * @summary Returns the admin-configured upgrade/downgrade options for the member's
enrollment, with per-target eligibility (locked downgrades carry the
commitment unlock date) and any pending scheduled change.
 */

export function useGetMembershipChangeOptions<TData = Awaited<ReturnType<typeof getMembershipChangeOptions>>, TError = ErrorType<void>>(
 platformUserMembershipId: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getMembershipChangeOptions>>, TError, TData>, request?: SecondParameter<typeof customAxios>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetMembershipChangeOptionsQueryOptions(platformUserMembershipId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






/**
 * @summary Schedules an upgrade/downgrade to apply at the member's next renewal. No
charge happens today; the Stripe subscription is repriced so the next
renewal invoice bills the new plan on the saved payment method.
 */
export const changeMembership = (
    platformUserMembershipId: string,
    changeMembershipRequest: ChangeMembershipRequest,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipPendingChange>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/change-membership`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: changeMembershipRequest, signal
    },
      options);
    }




export const getChangeMembershipMutationKey = () => ['changeMembership'] as const;

export const getChangeMembershipMutationOptions = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMembership>>, TError,ChangeMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof changeMembership>>, TError,ChangeMembershipMutationVariables, TContext> => {

const mutationKey = getChangeMembershipMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeMembership>>, ChangeMembershipMutationVariables> = (props) => {
          const {platformUserMembershipId,data} = props ?? {};

          return  changeMembership(platformUserMembershipId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ChangeMembershipMutationResult = NonNullable<Awaited<ReturnType<typeof changeMembership>>>
    export type ChangeMembershipMutationBody = ChangeMembershipRequest
    export type ChangeMembershipMutationError = ErrorType<void>
    export type ChangeMembershipMutationVariables = {platformUserMembershipId: string;data: ChangeMembershipRequest}

    /**
 * @summary Schedules an upgrade/downgrade to apply at the member's next renewal. No
charge happens today; the Stripe subscription is repriced so the next
renewal invoice bills the new plan on the saved payment method.
 */
export const useChangeMembership = <TError = ErrorType<void>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeMembership>>, TError,ChangeMembershipMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof changeMembership>>,
        TError,
        ChangeMembershipMutationVariables,
        TContext
      > => {
      return useMutation(getChangeMembershipMutationOptions(options));
    }
    /**
 * @summary Rescinds the member's pending membership change and restores the Stripe
subscription to the current plan's price.
 */
export const rescindMembershipChange = (
    platformUserMembershipId: string,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<DisplayMembershipChangeRescinded>(
      {url: `/api/v1/platform-user-memberships/${platformUserMembershipId}/change-membership`, method: 'DELETE', signal
    },
      options);
    }




export const getRescindMembershipChangeMutationKey = () => ['rescindMembershipChange'] as const;

export const getRescindMembershipChangeMutationOptions = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescindMembershipChange>>, TError,RescindMembershipChangeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
): UseMutationOptions<Awaited<ReturnType<typeof rescindMembershipChange>>, TError,RescindMembershipChangeMutationVariables, TContext> => {

const mutationKey = getRescindMembershipChangeMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rescindMembershipChange>>, RescindMembershipChangeMutationVariables> = (props) => {
          const {platformUserMembershipId} = props ?? {};

          return  rescindMembershipChange(platformUserMembershipId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RescindMembershipChangeMutationResult = NonNullable<Awaited<ReturnType<typeof rescindMembershipChange>>>

    export type RescindMembershipChangeMutationError = ErrorType<ProblemDetails>
    export type RescindMembershipChangeMutationVariables = {platformUserMembershipId: string}

    /**
 * @summary Rescinds the member's pending membership change and restores the Stripe
subscription to the current plan's price.
 */
export const useRescindMembershipChange = <TError = ErrorType<ProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rescindMembershipChange>>, TError,RescindMembershipChangeMutationVariables, TContext>, request?: SecondParameter<typeof customAxios>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof rescindMembershipChange>>,
        TError,
        RescindMembershipChangeMutationVariables,
        TContext
      > => {
      return useMutation(getRescindMembershipChangeMutationOptions(options));
    }
